module.exports = __webpack_public_path__ + "static/media/image2.cb3f64b6.JPG";